// Taken from https://redux.js.org/recipes/reducing-boilerplate#generating-reducers
// to reduce boilerplate
export function createReducer(initialState, handlers) {
  return function reducer(state = initialState, action) {
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action)
    } else {
      return state
    }
  }
}


// Taken from https://redux.js.org/recipes/structuring-reducers/refactoring-reducers-example#extracting-utility-functions
//
// Encapsulate the idea of passing a new object as the first parameter
// to Object.assign to ensure we correctly copy data instead of mutating
export function updateObject(oldObject, newValues) {
  return Object.assign({}, oldObject, newValues);
}


// WEBPACK FOOTER //
// ./src/reducers/reducerUtilities.js